/* * @Author: 曹俊杰 * @Date: 2024-12-13 11:46:23 * @Last Modified by: mikey.zhaopeng *
@Last Modified time: 2025-05-21 02:17:01 */签署信息
<template>
  <div class="signers">
    <div v-for="(item, index) in list" :key="item.uuid" class="item">
      <div>
        <span>{{ item.operatorName }}</span>
        <span v-if="item.signerType == 'ORG'">（操作人）</span>
      </div>
      <div style="margin: 0 5px; color: #eee" v-if="item.state !== 'FINISHED'">|</div>
      <div
        v-if="item.state === 'IN_PROGRESS'"
        style="color: #0062ff"
        class="pointer"
        @click="getSignerUrl(item, index)"
      >
        签署
      </div>
      <img
        v-if="item.state === 'FINISHED'"
        src="@/assets/image/home/yiqianshu.webp"
        style="height: 11px; width: 11px; margin-left: 10px"
        alt=""
        srcset=""
      />
      <!-- <div v-if="item.state === 'FINISHED'" style="color: #00a646">已签署</div> -->
      <div v-if="item.state === 'PENDING'" style="color: #ff8412">待审批</div>
      <div v-if="item.state === 'REFUSED'" style="color: #ff0d0d">拒签</div>
    </div>
    <qrDialog ref="qrDialog" @close="close" title="扫码进行签署">
      <template #desc>
        <div class="desc">签署代表您的真实意愿并将产生相应的法律效力</div>
      </template>
      <template>
        <span style="margin-top: 16px">
          <span v-if="name">可通知【{{ name }}】</span>
          <span>使用</span>
          <span style="color: #0062ff">「微信账号」</span>
          <span>或</span>
          <span style="color: #0062ff">「支付宝账号」</span>
          <span>扫码完成签署</span>
        </span>
      </template>
    </qrDialog>
  </div>
</template>

<script>
import qrDialog from "@/components/qrDialog.vue";
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    qrDialog,
  },
  data() {
    return {
      name: "",
    };
  },
  computed: {},
  methods: {
    close() {
      this.name = "";
    },
    //  此处判断操作人   第一条是操作人， 上面判断操作人是根据企业还是个人  企业是操作人   感觉有问题 不论是第一条还是企业类型  都不一定是操作人
    async getSignerUrl({ uuid, operatorName }, index) {
      const { status, data, info } = await this.$api.getSignerUrl({ uuid });
      if (status === 200) {
        if (index) {
          this.name = operatorName;
        }
        this.$refs.qrDialog.show(data.signUrl);
      } else {
        this.$message({
          type: "error",
          message: info,
        });
      }
      console.log(data);
    },
  },
};
</script>

<style scoped lang="scss">
.signers {
  min-width: 150px;
  .item {
    display: flex;
    font-size: 12px;
    align-items: center;
  }
  .desc {
    height: 50px;
    font-size: 14px;
    font-weight: 350;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
